import React, { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";

import {
  useEditQuizMutation,
  useGetQuizQuery,
} from "../../features/quizzes/quizzesApi";
import { useGetVideosQuery } from "../../features/videos/videosApi";
import Error from "../ui/Error";
import Loading from "../ui/Loading";
import styles from "./quizForm.module.css";

export default function QuizEditForm() {
  const { quizId } = useParams();
  const navigate = useNavigate();
  const questionRef = useRef();
  const chooseVideoRef = useRef();

  const option1Ref = useRef();
  const option1CheckRef = useRef();

  const option2Ref = useRef();
  const option2CheckRef = useRef();

  const option3Ref = useRef();
  const option3CheckRef = useRef();

  const option4Ref = useRef();
  const option4CheckRef = useRef();

  const { data: videos } = useGetVideosQuery();
  const {
    data: quiz,
    isSuccess,
    isLoading,
    isError,
    error,
  } = useGetQuizQuery(quizId, {
    refetchOnMountOrArgChange: true,
  });

  const [editQuiz, { isSuccess: isEditSuccess }] = useEditQuizMutation();

  const handleEdit = (e) => {
    e.preventDefault();
    const videoTitle = videos?.find(
      (video) => video.id === Number(chooseVideoRef.current.value)
    ).title;
    const data = {
      question: questionRef?.current.value,
      video_id: Number(chooseVideoRef.current.value),
      video_title: videoTitle,
      options: [
        {
          id: 1,
          option: option1Ref?.current.value,
          isCorrect: option1CheckRef.current.checked,
        },
        {
          id: 2,
          option: option2Ref?.current.value,
          isCorrect: option2CheckRef.current.checked,
        },
        {
          id: 3,
          option: option3Ref?.current.value,
          isCorrect: option3CheckRef.current.checked,
        },
        {
          id: 4,
          option: option4Ref?.current.value,
          isCorrect: option4CheckRef.current.checked,
        },
      ],
    };

    editQuiz({ id: quizId, data });
  };

  // decide what to render
  let content = null;
  if (isLoading) {
    content = <Loading />;
  } else if (!isLoading && isError) {
    content = <Error message={error} />;
  } else if (!isLoading && !isError && quiz?.id) {
    content = (
      <form
        onSubmit={handleEdit}
        className={`${styles.videoForm}  bg-primary border border-slate-50/10 `}
      >
        <div className="formGroup flex items-center justify-between">
          <label htmlFor="questionInput">Question</label>
          <input
            required
            className="bg-slate-900 p-2 "
            type="text"
            id="questionInput"
            ref={questionRef}
          />
        </div>
        <div className="formGroup flex items-center justify-between">
          <label htmlFor="chooseVideoSelect">Choose video</label>
          <select
            ref={chooseVideoRef}
            id="chooseVideoSelect"
            className="bg-slate-900 p-2 "
            defaultValue={1}
          >
            {videos?.map((video) => (
              <option value={video.id} key={video.id}>
                {video.title}
              </option>
            ))}
          </select>
        </div>

        <div className="formGroup flex items-center justify-between">
          <label
            htmlFor="option1Input"
            className="flex items-center gap-2"
            style={{ whiteSpace: "noWrap" }}
          >
            <input
              ref={option1CheckRef}
              className="cursor-pointer"
              type="checkbox"
              title="Is this option is correct"
            />
            Option 1
          </label>
          <input
            required
            className="bg-slate-900 p-2 "
            type="text"
            id="option1Input"
            ref={option1Ref}
          />
        </div>
        <div className="formGroup flex items-center justify-between">
          <label
            htmlFor="option2Input"
            className="flex items-center gap-2"
            style={{ whiteSpace: "noWrap" }}
          >
            <input
              ref={option2CheckRef}
              className="cursor-pointer"
              type="checkbox"
              title="Is this option is correct"
            />
            Option 2
          </label>
          <input
            required
            className="bg-slate-900 p-2 "
            type="text"
            id="option2Input"
            ref={option2Ref}
          />
        </div>
        <div className="formGroup flex items-center justify-between">
          <label
            htmlFor="option3Input"
            className="flex items-center gap-2"
            style={{ whiteSpace: "noWrap" }}
          >
            <input
              ref={option3CheckRef}
              className="cursor-pointer"
              type="checkbox"
              title="Is this option is correct"
            />
            Option 3
          </label>
          <input
            required
            className="bg-slate-900 p-2 "
            type="text"
            id="option3Input"
            ref={option3Ref}
          />
        </div>
        <div className="formGroup flex items-center justify-between">
          <label
            htmlFor="option4Input"
            className="flex items-center gap-2"
            style={{ whiteSpace: "noWrap" }}
          >
            <input
              ref={option4CheckRef}
              className="cursor-pointer"
              type="checkbox"
              title="Is this option is correct"
            />
            Option 4
          </label>
          <input
            required
            className="bg-slate-900 p-2 "
            type="text"
            id="option4Input"
            ref={option4Ref}
          />
        </div>

        <button
          type="submit"
          className="block ml-auto bg-violet-600 p-2 px-4 rounded-md text-white"
        >
          Save
        </button>
      </form>
    );
  }

  useEffect(() => {
    if (isSuccess && questionRef?.current) {
      // set the value of all the inputs
      questionRef.current.value = quiz?.question;
      chooseVideoRef.current.value = quiz?.video_id;
      option1Ref.current.value = quiz?.options[0].option;
      option2Ref.current.value = quiz?.options[1].option;
      option3Ref.current.value = quiz?.options[2].option;
      option4Ref.current.value = quiz?.options[3].option;

      option1CheckRef.current.checked = quiz?.options[0].isCorrect;
      option2CheckRef.current.checked = quiz?.options[1].isCorrect;
      option3CheckRef.current.checked = quiz?.options[2].isCorrect;
      option4CheckRef.current.checked = quiz?.options[3].isCorrect;
    }
    if (isEditSuccess) {
      navigate("/admin/quizzes");
    }
  });

  return (
    <>
      <div className="justify-center mb-10 space-y-2 flex md:space-y-0">
        {content}
      </div>
    </>
  );
}
